import React from 'react';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom';

import Root from './containers/Root';
import configureStore from './configureStore';
import './index.css';

const store = configureStore();

ReactDOM.render(
  <Provider store={store}>
    <Root />
  </Provider>,
  document.getElementById('root')
);
